import styled from "styled-components";

interface IWheelDialogCirclesBgImgDefaultBoxProps {
    innerOrOuter: "inner" | "outer";
}

export const WheelDialogCirclesBgImgDefaultBox = styled.img<IWheelDialogCirclesBgImgDefaultBoxProps>`
    display: block;
    position: absolute;

    top: 50%;
    left: 50%;
    /* transform: translate(-49.11%, -55%) scale(2.4); */
    transform: ${props => props.innerOrOuter === "inner" ? "translate(-47.5%, -65%) scale(2.4)" : "translate(-47.5%, -70%) scale(5)"};
`;